import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFacebookF, faTwitter, faLinkedinIn, faInstagram, faYoutube 
} from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-column">
            <h3>CodexLNC</h3>
            <p>Empowering the next generation of Salesforce professionals with industry-relevant training and career support.</p>
            <div className="social-links">
              {/* <a href="#"><FontAwesomeIcon icon={faFacebookF} /></a> */}
              {/* <a href="#"><FontAwesomeIcon icon={faTwitter} /></a> */}
               <a href="https://www.linkedin.com/in/malyala-kalyan-chakravarthy-goud-844745219/" target="_blank" rel="noreferrer">
                              <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
              {/* <a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a> */}
              <a href="#https://www.instagram.com/salesforcewithkc/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
              <a href="#https://www.youtube.com/@SalesforceWithKC" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
            </div>
          </div>
          <div className="footer-column">
            <h3>Courses</h3>
            <ul>
              <li><Link to="/salesforce-platform-developer">Platform Developer 1</Link></li>
              <li><Link to="/salesforce-business-analyst">Business Analyst</Link></li>
              <li><Link to="/salesforce-lwc-developer">Lightning Web Components</Link></li>
              <li><Link to="/salesforce-ai-bootcamp">Salesforce AI bootcamp </Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Resources</h3>
            <ul>
              <li><Link to="/free-courses">Free Tutorials</Link></li>
              <li><Link to="/free-courses">Blog</Link></li>
              <li><Link to="/contact">Career Guide</Link></li>
              <li><Link to="/contact">Interview Prep</Link></li>
            </ul>
          </div>
          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              {/* <li><Link to="/success-stories">Success Stories</Link></li> */}
              <li><Link to="/contact">Contact Us</Link></li>
              {/* <li><Link to="/privacy-policy">Privacy Policy</Link></li> */}
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} CodexLNC.com. All Rights Reserved. *Terms and conditions apply</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;